export const dispatchType = ({ variant } = {}) => {
  const dispatchPrimary = {
    solid: 'ds-primary',
    text: 'ds-primary-text',
  };
  const dispatchSecondary = {
    solid: 'ds-secondary',
    text: 'ds-secondary-text',
  };
  const dispatchDanger = {
    solid: 'ds-danger',
    text: 'ds-danger-text',
  };
  const dispatchSuccess = {
    solid: 'ds-success',
    text: 'ds-success-text',
  };
  const dispatchWarning = {
    solid: 'ds-warning',
    text: 'ds-warning-text',
  };
  const dispatchInfo = {
    solid: 'ds-info',
    text: 'ds-info-text',
  };

  return {
    default: '',
    primary: dispatchPrimary?.[variant],
    secondary: dispatchSecondary?.[variant],
    danger: dispatchDanger?.[variant],
    success: dispatchSuccess?.[variant],
    warning: dispatchWarning?.[variant],
    info: dispatchInfo?.[variant],
  };
};

export const dispatchSize = () => ({
  xs: 'ds-xs',
  sm: 'ds-sm',
  md: 'ds-md',
  lg: 'ds-lg',
});

export const dispatchVariant = () => ({
  solid: 'ds-btn',
  text: 'ds-btn-text',
});
